import {
  Card,
  Flex,
  Skeleton,
  Spoiler,
  Text,
  Title,
  type BoxProps,
} from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreProduct } from '@flecto/types'

import { SectionBundleItems } from './SectionBundleItems'

export type CardProductDescriptionProps = BoxProps & {
  product?: CoreProduct
  isLoading?: boolean
}

export function CardProductDescription({
  product,
  isLoading,
  ...props
}: CardProductDescriptionProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-product' })

  if (isLoading) {
    return (
      <Card {...props}>
        <Skeleton h={20} w={150} radius='xl' />
        <Flex mt='md' gap='sm' direction='column'>
          <Skeleton h={15} />
          <Skeleton h={15} />
          <Skeleton h={15} />
        </Flex>
      </Card>
    )
  }

  if (!product) {
    return
  }

  return (
    <Card {...props}>
      <Title order={4} mb='sm'>
        {t('label_description')}
      </Title>
      <Spoiler
        maxHeight={75}
        showLabel={t('label_description_more')}
        hideLabel={t('label_description_hide')}
      >
        <Text
          size='lg'
          dangerouslySetInnerHTML={{ __html: product?.description }}
        />
      </Spoiler>

      <SectionBundleItems product={product} mt='lg' pt='lg' />
    </Card>
  )
}
